import api from "./api";

export const registerVehicleForUser =
    async (
        userId,
        payload
    ) => {
        try {
            const formData =
                new FormData();

            formData.append(
                "user_id",
                userId
            );

            Object.entries(
                payload
            ).forEach(
                ([key, value]) => {
                    if (
                        ![
                            "blue_book",
                            "vehicle_image",
                        ].includes(
                            key
                        )
                    ) {
                        formData.append(
                            key,
                            value
                        );
                    }
                }
            );

            formData.append(
                "blue_book",
                payload.blue_book[0]
                    ?.file
            );

            formData.append(
                "vehicle_image",
                payload.vehicle_image[0]
                    ?.file
            );

            const response =
                await api.post(
                    "/vehicle-management/vehicles/register-for-user",
                    formData,
                    {
                        headers: {
                            "Content-Type":
                                "multipart/form-data",
                        },
                    }
                );

            return {
                success: true,
                data:
                    response.data.data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    error.message,
            };
        }
    };

export const fetchRecruitedVehicles =
    async (
        page = 1,
        size = 10
    ) => {
        try {
            const response =
                await api.get(
                    `/vehicle-management/driver-partners/recruited-vehicles?page=${page}&size=${size}`
                );

            return {
                success: true,
                data:
                    response.data.data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    error.message,
            };
        }
    };